import { Tooltip } from '@material-ui/core';

import NotificationTypeIcon from './notification.type.icon';
import datetimeProvider from '../../providers/datetime.provider';

export default function NotificationItem({ notification, onClick = () => { } }) {

    const isUnread = !notification.viewedAt;

    return (
        <button
            type="button"
            onClick={() => onClick(notification)}
            className={`w-full text-left flex gap-3 px-4 py-3 border-b border-[#f4f5f7] last:border-b-0 transition-colors hover:bg-gray-50 ${isUnread ? 'bg-[#f5f8ff]' : 'bg-white'}`}
        >
            <NotificationTypeIcon layoutInfo={notification.additionalData?.layoutInfo} />

            <div className="min-w-0 flex-1">
                <div className="flex items-baseline justify-between gap-2">
                    <span className={`text-[13.5px] leading-tight ${isUnread ? 'font-semibold' : 'font-medium'}`}>
                        {notification.title}
                    </span>
                    <Tooltip title={datetimeProvider.formatDateTime(notification.createdAt, undefined, true)}>
                        <span className="flex-none whitespace-nowrap text-[11px] text-black/40">
                            {datetimeProvider.formatShortRelativeTime(notification.createdAt)}
                        </span>
                    </Tooltip>
                </div>
                <p className="mt-[3px] text-[12.5px] leading-[1.45] text-black/[.56] whitespace-pre-wrap">
                    {notification.description}
                </p>
            </div>
        </button>
    );
}
